export default (editor, opts = {}) => {
    
    editor.on('asset:upload:start', async (some, argument) => {
        console.log({some, argument});
    });
};
